<template>
  <!-- 面包屑 -->
<!--  <a-breadcrumb>-->

<!--    <a-breadcrumb-item>Home</a-breadcrumb-item>-->
<!--    <a-breadcrumb-item><a href="">Application Center</a></a-breadcrumb-item>-->
<!--    <a-breadcrumb-item><a href="">Application List</a></a-breadcrumb-item>-->
<!--    <a-breadcrumb-item>An Application</a-breadcrumb-item>-->
<!--  </a-breadcrumb>-->
  <a-breadcrumb separator='/'>
    <a-breadcrumb-item style="padding:5px">
      <router-link :to="'/'" style="font-size:18px">首页</router-link>
    </a-breadcrumb-item>
    <a-breadcrumb-item v-for="(item,index) of routes" :key="index" style="padding:5px">
      <router-link :to="item.path" style="font-size:18px">{{item.meta.title}}</router-link>
    </a-breadcrumb-item>
  </a-breadcrumb>
</template>
<script>
export default {
  name: 'Breadcrumb',
  watch :{
    '$route':'init'
  },
  mounted(){
    console.log(this.$route)
  },
  computed:{
    routes(){
      return this.$route.matched.filter(v=>v.components.default.name!=='Home' && v.components.default.name!=='FirstHome' && v.name);
    }
  },
  methods:{
    init(){
      console.log(this.$route)
    }
  }
};
</script>
<style scoped>
.ant-breadcrumb a{
  font-size: 15px !important;
}
</style>
